import { twMerge } from "tailwind-merge";
import { Skeleton } from "@components/Skeleton/Skeleton";

interface IBankButtonSkeletonProps {
  className?: string;
}

export const BankButtonSkeleton: React.FC<IBankButtonSkeletonProps> = (
  props,
) => {
  const { className } = props;

  return (
    <Skeleton className={twMerge("ounded-lg h-[72px] min-w-52", className)} />
  );
};
